import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { portfolioData } from "../data/portfolioData";
import { fetchPortfolioDataFromSheet } from "../services/googleSheetService";

export const fetchPortfolioData = createAsyncThunk(
  "portfolio/fetchPortfolioData",
  async () => {
    return await fetchPortfolioDataFromSheet();
  }
);

const initialState = {
  ...portfolioData,
  loading: false,
  error: null,
};

const portfolioSlice = createSlice({
  name: "portfolio",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPortfolioData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPortfolioData.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = {
          ...state.profile,
          ...action.payload.profile,
        };
        state.navItems = action.payload.navItems;
        state.workItems = action.payload.workItems;
        state.workItemsTimeline = action.payload.workItemsTimeline;
        state.games = action.payload.games;
        state.aiItems = action.payload.aiItems;
      })
      .addCase(fetchPortfolioData.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to load Google Sheet data";
      });
  },
});

export default portfolioSlice.reducer;